import {ActivityTimeline} from "~/modules/activityTimeline/ActivityTimeline";
import type {ProfileTabRenderProps} from "~/components/entityProfile/types";
import type {EventContainerWithEvents} from "~/utilities/apis/api";

export function ProfileActivityTabContent({
    tabRenderProps,
    journey,
}: {
    tabRenderProps: ProfileTabRenderProps;
    journey: EventContainerWithEvents;
}) {
    if (tabRenderProps.kind !== "journey") {
        return (
            <div className="p-ds-space-200 text-ds-text-subtle text-sm">
                Customer activity will be available in a later phase.
            </div>
        );
    }

    return (
        <div className="flex h-full min-h-0 flex-col overflow-hidden">
            <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-ds-space-200 pb-ds-space-200">
                <ActivityTimeline eventContainer={journey} />
            </div>
        </div>
    );
}
